module.exports = __webpack_public_path__ + "static/media/sama10.ca5824ce.wav";